






































import {
  defineComponent,
  PropType,
  ref,
  computed,
  onMounted,
  watch
} from '@vue/composition-api'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/free-regular-svg-icons'

library.add(faCheckCircle, faTimesCircle)

import Loader from './Loader.vue'
import Status from './Status.vue'

import { TShirtSize } from '@/lib/sizing'
import { Orientation } from '@/lib/positioning'
import { copyToClipboard } from '@/lib/clipboard'
import { ApiError } from '../errors/api.errors'

export default defineComponent({
  components: {
    Loader,
    Status
  },
  props: {
    apiCall: Promise as PropType<Promise<unknown>>,
    label: String,
    successMessage: String,
    successDetail: String,
    failureMessage: String,
    failureDetail: String,
    size: {
      type: String as PropType<TShirtSize>,
      default: 'medium'
    },
    color: {
      type: String,
      default: 'text-gray-500'
    },
    layout: {
      type: String as PropType<Orientation>,
      default: 'vertical'
    },
    timer: {
      type: Boolean,
      default: false
    },
    waiting: {
      type: Boolean,
      default: false
    },
    allowRetry: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const loading = ref(true)
    const success = ref(false)
    const failure = ref(false)
    const error = ref(null)
    const timerActive = ref(true)
    const messageTimeout = ref(500)
    const showRetry = ref(false)

    const load = () => {
      timerActive.value = true
      loading.value = true
      showRetry.value = false
      success.value = false
      failure.value = false
      props.apiCall
        ?.then(resp => {
          if ((resp as ApiError) && (resp as ApiError).message) {
            throw (resp as ApiError).message
          }
          if (
            (resp as any) &&
            (resp as any).error &&
            (resp as any).error.formErrors
          ) {
            throw new Error((resp as any).error.formErrors.join(', '))
          }
          success.value = true
        })
        ?.catch(e => {
          error.value = e
          failure.value = true
          if (props.allowRetry) {
            showRetry.value = true
          }
          console.error(e)
        })
        ?.finally(() => {
          if (props.timer) {
            setTimeout(() => {
              timerActive.value = false
            }, messageTimeout.value)
          }
          loading.value = false
        })
    }
    const retry = () => {
      emit('retry', true)
    }

    watch(() => props.apiCall, load, {})

    onMounted(load)

    const copyErrorToClipboard = computed(() =>
      copyToClipboard(`${props.failureMessage}\n${props.failureDetail}`)
    )

    return {
      loading,
      timerActive,
      success,
      failure,
      error,
      copyErrorToClipboard,
      showRetry,
      retry
    }
  }
})
